import type { FC } from 'react';

import { Card, Grid, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import type { ContactInfo } from 'constants/_types/ContactInfo';
import helpMessages from 'translations/specific/help.mjs';

import useStyles from './MobileContactTile.styles';

export interface Props {
  header: string;
  info: ContactInfo;
}

const MobileContactTile: FC<Props> = ({ header, info: { address, email, logoAlt, logoSrc, phoneNumber } }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles();

  return (
    <Card className={classes.root}>
      <Grid className={classes.contactBox} item xs={12}>
        <Typography variant='subtitle3'>{header}</Typography>
        {logoSrc ? (
          <img alt={logoAlt} className={classes.image} src={logoSrc} />
        ) : (
          <Typography component='p' variant='captionBold'>
            {logoAlt}
          </Typography>
        )}
        <div>
          <Typography color={theme.palette.grey[500]} variant='captionBold'>
            {t(helpMessages.hotline)}
          </Typography>
          <Typography
            className={classes.phoneNumber}
            color={theme.palette.primary.main}
            component='a'
            href={`tel:${phoneNumber}`}
            variant='subtitle1'
          >
            {phoneNumber}
          </Typography>
        </div>
        <Typography component='p' variant='captionBold'>
          {address}
        </Typography>
        <Typography className={classes.email} component='a' href={`mailto:${email}`} variant='captionBold'>
          {email}
        </Typography>
      </Grid>
    </Card>
  );
};

export default MobileContactTile;
